import styled from "styled-components";
import { setContainer } from "@titelmedia/bricks-theme/lib/utilities/layout";

export const Container = styled.div`
  ${props => (props.rounded ? setContainer({ size: "xl" }) : "")};
`;

export const VideoContainer = styled.div`
  position: relative;
  background-color: grey;
  background-image: url(${props => (props.video ? "" : props.src)});
  background-size: cover;

  pointer-events: none;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  border-radius: ${props => (props.rounded ? "20px" : 0)};
  padding: 0;

  iframe {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    pointer-events: all !important;
  }

  @media (min-width: 768px) {
    border-radius: ${props => (props.rounded ? "24px" : 0)};
    /* iframe {
      left: -80vw;
    } */
  }

  @media (min-width: 992px) {
    padding-bottom: 56.25%; /* 16:9 */
    border-radius: ${props => (props.rounded ? "28px" : 0)};
    iframe {
      /* width: 100%;
      height: 100%; */
      //left: 0;
    }
  }
`;

export const Title = styled.h1`
  position: absolute;
  text-align: center;

  font-size: 55px;
  font-family: "univers-black";
  line-height: 110%;
  letter-spacing: -2%;
  weight: 75;
  z-index: 1;
  margin: 0;
  text-transform: uppercase;
  color: ${props => (props.color ? props.color : "#000")};

  top: 50vh;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: 992px) {
    top: 50%;
  }
`;
